import { useCoachQuery } from '@/features/home/queries';
import { useSessionStore } from '@/stores';
import { useNavigation } from '@react-navigation/native';
import { ComponentType, useEffect, useEffectEvent } from 'react';
import { useShallow } from 'zustand/shallow';

export function withActiveSession<P extends object>(WrappedComponent: ComponentType<P>) {
  function WithActiveSessionScreen(props: P) {
    const navigation = useNavigation();
    const userUid = useSessionStore(useShallow(state => state.user?.uid));
    const { data: coach } = useCoachQuery(userUid);

    const checkActiveSession = useEffectEvent(() => {
      if (!coach?.active_session_id) {
        navigation.goBack();
      }
    });

    useEffect(() => {
      checkActiveSession();
    }, [coach?.active_session_id]);

    if (!coach?.active_session_id) {
      return null;
    }

    return <WrappedComponent {...props} />;
  }

  WithActiveSessionScreen.displayName = `withActiveSession(${
    WrappedComponent.displayName ?? WrappedComponent.name ?? 'WithActiveSessionScreen'
  })`;

  return WithActiveSessionScreen;
}
